var map = {
	"./city/new/avatar-1.png": 59234,
	"./city/new/avatar-2.png": 80769,
	"./city/new/avatar-3.png": 34227,
	"./city/new/boost-list-icon-1.png": 55506,
	"./city/new/boost-list-icon-2.png": 9782,
	"./city/new/boost-list-icon-3.png": 57391,
	"./city/new/boost-list-icon-4.png": 44545,
	"./city/new/btn-icon-boost.png": 2723,
	"./city/new/city-bg.jpg": 34156,
	"./city/new/city-img-1.jpg": 96299,
	"./city/new/city-img-2.jpg": 8872,
	"./city/new/city-menu-lock.png": 88249,
	"./city/new/city-menu-premiumStore.png": 34068,
	"./city/new/coin.png": 11169,
	"./city/new/earn-head-img.png": 40836,
	"./city/new/friend-head-bg.jpg": 33679,
	"./city/new/friends-img-1.png": 73037,
	"./city/new/friends-img-2.png": 12609,
	"./city/new/head-icon-rank.png": 77462,
	"./city/new/head-icon-squad-active.png": 75677,
	"./city/new/head-icon-squad.png": 70353,
	"./city/new/icon-daily-bounty.png": 58462,
	"./city/new/icon-daily-check-in.png": 35629,
	"./city/new/icon-daily-invite.png": 62010,
	"./city/new/icon-info.png": 46523,
	"./city/new/icon-lock.png": 63813,
	"./city/new/icon-menu.png": 28560,
	"./city/new/icon-ok.png": 94763,
	"./city/new/index-bg-basic.jpg": 54651,
	"./city/new/index-bg-basic2.jpg": 89781,
	"./city/new/index-bg-basic3.jpg": 44501,
	"./city/new/index-bg-basic4.jpg": 71694,
	"./city/new/index-btn-boost.png": 32152,
	"./city/new/index-btn-city-active.png": 67563,
	"./city/new/index-btn-city.png": 91872,
	"./city/new/index-btn-frens-active.png": 17984,
	"./city/new/index-btn-frens.png": 76214,
	"./city/new/index-btn-improve-active.png": 29482,
	"./city/new/index-btn-improve.png": 40045,
	"./city/new/index-btn-play-active.png": 69633,
	"./city/new/index-btn-play.png": 82700,
	"./city/new/index-btn-task-active.png": 19280,
	"./city/new/index-btn-task.png": 83653,
	"./city/new/index-icon-progress.png": 45734,
	"./city/new/index-icon-small-coin.png": 32368,
	"./city/new/level/Bronze.jpg": 18274,
	"./city/new/level/Diamond.jpg": 70729,
	"./city/new/level/Emerald.jpg": 78872,
	"./city/new/level/Gold.jpg": 12884,
	"./city/new/level/Platinum.jpg": 65761,
	"./city/new/level/Ruby.jpg": 47018,
	"./city/new/level/Silver.jpg": 23491,
	"./city/new/menu-bg.png": 25633,
	"./city/new/nav-bg.png": 64292,
	"./city/new/rank-1.png": 42742,
	"./city/new/rank-2.png": 67512,
	"./city/new/rank-3.png": 84705,
	"./city/new/tasks-daily-icon-bg1.jpg": 80266,
	"./city/new/tasks-daily-icon-bg2.jpg": 89105,
	"./city/new/tasks-daily-icon-bg3.jpg": 49226
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22477;